"use client";

import React from "react";
import { CheckCircle, Loader, AlertCircle, FileAudio2 } from "lucide-react";
import { UploadStatus } from "..";

type StatusDisplayProps = {
  status: UploadStatus;
  audioUrl?: string;
  fileName?: string;
};

export const StatusDisplay: React.FC<StatusDisplayProps> = ({ status, audioUrl, fileName }) => {
  if (status.state === "SUCCESS") {
    return (
      <div className="fade-in slide-up p-4 relative" style={{
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderRadius: 'var(--card-radius)',
        border: 'var(--glass-border)',
        boxShadow: 'var(--glass-shadow)',
      }}>
        <div className="bg-success/10 rounded-lg border border-success/20 p-4">
          {/* ステータス情報 */}
          <div className="flex items-center justify-center mb-3">
            <CheckCircle className="h-8 w-8 text-success mr-3" />
            <div className="text-center">
              <h3 className="text-base font-medium text-success mb-0">ファイルセット完了</h3>
              <p className="text-xs text-success/80">ファイルの処理が開始されました</p>
            </div>
          </div>
          
          {/* 音声ファイル情報 */}
          {audioUrl && fileName && (
            <div className="border-t border-success/20 pt-3">
              <div className="flex items-center mb-2">
                <FileAudio2 className="h-4 w-4 text-success mr-2" />
                <p className="text-xs font-medium text-success">アップロードした音声ファイル</p>
              </div>
              <p className="text-xs text-success/80 mb-2 truncate">{fileName}</p>
              <audio controls src={audioUrl} className="w-full h-8 rounded-md focus:outline-none focus:ring-1 focus:ring-success">
                お使いのブラウザはオーディオタグをサポートしていません
              </audio>
            </div>
          )}
        </div>
      </div>
    );
  }
  
  if (status.state === "SAVING") {
    return (
      <div className="fade-in slide-up px-8 pb-8 pt-10 relative" style={{
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderRadius: 'var(--card-radius)',
        border: 'var(--glass-border)',
        boxShadow: 'var(--glass-shadow)',
        // backgroundColor: 'rgba(255, 255, 255, 0.5)'
      }}>
        <div className="flex flex-col items-center justify-center p-6 bg-white/10 rounded-lg border border-primary/20">
          <Loader className="animate-spin h-16 w-16 text-primary mb-4" />
          <h3 className="text-lg font-medium text-primary mb-1">処理中...</h3>
          <p className="text-sm text-primary/80 text-center">ファイルを処理しています</p>
        </div>
      </div>
    );
  }
  
  if (status.state === "ERROR") {
    return (
      <div className="fade-in slide-up p-6 relative" style={{
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderRadius: 'var(--card-radius)',
        border: 'var(--glass-border)',
        boxShadow: 'var(--glass-shadow)',
        // backgroundColor: 'rgba(255, 255, 255, 0.5)'
      }}>
        <div className="flex flex-col items-center justify-center p-6 bg-error/10 rounded-lg border border-error/20">
          <AlertCircle className="h-16 w-16 text-error mb-4" />
          <h3 className="text-lg font-medium text-error mb-1">エラーが発生しました</h3>
          <p className="text-sm text-error/80 text-center">{status.message}</p>
        </div>
      </div>
    );
  }
  
  return null;
}; 